module.exports = __webpack_public_path__ + "20230117/media/2.1758ff8.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/mp3/2.mp3
// module id = qSKN
// module chunks = 1